import { FormControl, Stack } from "@mui/material";
import { isEmpty } from "lodash";
import { type FC, type PropsWithChildren } from "react";
import { useController } from "react-hook-form";
import * as StyledCommon from "./Common.styled";
import { FormError } from "./FormError";

export type FieldsetProps = PropsWithChildren<{
    name: string;
    label?: string;
}>;

/// Fieldset groups form elements and can handle group validation using react-hook-form.
export const Fieldset: FC<FieldsetProps> = ({ children, label, name }) => {
    const {
        fieldState: { error },
    } = useController({ name });

    return (
        <Stack>
            {!isEmpty(label) && <StyledCommon.InputLabel>{label}</StyledCommon.InputLabel>}
            <FormControl aria-labelledby={`fieldset-${name}`} component="fieldset">
                {children}
            </FormControl>
            <FormError error={error} fieldName={name} />
        </Stack>
    );
};
